/**
 * @ngdoc services
 * @memberof mercury.services
 * @name userfeedback
 * @description Injects a user feedback tool into the app
 */
angular.module('mercury.startup')
.run(["$rootScope", "logger", "features", "userinfo", function userfeedback($rootScope, logger, features, userinfo) {

  logger.info('userfeedback: Initializing...');
  let hasAlpha = false;
  let hasBeta = false;
  let hasLoaded = false;

  // List of routes that should show the feedback button and the conditions to be met
  // "all" means the marker will show for all users in this page
  // "hasAlpha" means the marker will show for users with the alpha flag
  // "hasBeta" means the marker will show for users with the beta flag
  // "hasLoaded" means the marker will show for users with the @loadedhub.com email
  const routesAcceptingFeedback = [
    {
      route: '#/stock/invoices',
      conditions: { all: true }
    },
  ];

  userinfo.ready().then(function() {
    features.isEnabled('alpha')
      .then(function(isAlpha) {
        hasAlpha = isAlpha;
        return features.isEnabled('beta')
      })
      .then(function(isBeta) {        
        hasBeta = isBeta;
      })
      .then(() => {
        const userDetails = userinfo.userDetails();
        hasLoaded = userDetails.email.endsWith("@loadedhub.com")
        setupMarkerIO(userDetails);
      })
    
  });

  /**
   * Injects marker.io as a user feedback tool
   * @param {*} userDetails 
   */
  function setupMarkerIO(userDetails) {
    window.markerConfig = {
      project: '6678b7a6ec5ae5df4270b88f',
      source: 'snippet',
      reporter: {
        email: userDetails.email,
        fullName: userDetails.name,
      },
    }

    !function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);

    // Once marker.io has loaded we check the current url to see if we should show the button
    Marker.on('load', function() {
      updateButtonVisibility();
    })

    // and on any navigations (AngularJS or React initiated) we check again
    $rootScope.$on('$locationChangeSuccess', function(e, newUrl, oldUrl, newState, oldState) {
      updateButtonVisibility();
    })

    window.addEventListener('@@loaded/reactNavigation', function() {
      updateButtonVisibility();
    })

    /**
     * Updates the visibility of the marker.io button based on the current url
     * checking against the allow list. Unfortunately marker.io doesn't allow
     * this to be configured via their UI.
     */
    function updateButtonVisibility() {
      const shouldShow = routesAcceptingFeedback.some(({ route, conditions }) => {
        // Check if the current route matches the route condition
        const routeMatches = route instanceof RegExp ?
          route.test(window.location.hash) :
          window.location.hash.startsWith(route);
    
        if (!routeMatches) return false;
        
        // Check the specific conditions for the route
        const { hasAlpha: condAlpha, hasBeta: condBeta, hasLoaded: condLoaded } = conditions;

        // Check if the route has "all" flag or if it has loaded user flag
        if (conditions.all || condLoaded === hasLoaded) return true;
    
        // Validate based on the conditions. Undefined means no check for that flag.
        return (condAlpha === undefined || condAlpha === hasAlpha) ||
                (condBeta === undefined || condBeta === hasBeta);
      });

      if (shouldShow) {
        Marker.show();
      } else {
        Marker.hide();
      }
    }
  }

}]);

